import { Button } from '@/common/ui/button'
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from '@/common/ui/alert-dialog'
import { Trash2 } from 'lucide-react'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import { useQueryClient } from '@tanstack/react-query'
import useMutationDeleteBankAccount from '@/modules/bank/api/hooks/useMutationDeleteBankAccount'
import { BankQueryKeys } from '@/modules/bank/keys'

interface DeleteBankModalProps {
	id: string
}

export default function DeleteBankModal({ id }: DeleteBankModalProps) {
	const queryClient = useQueryClient()
	const { mutate: deleteBankAccount } = useMutationDeleteBankAccount({
		onSuccess: () => {
			toast.success('ลบบัญชีธนาคารสำเร็จ')
			queryClient.invalidateQueries({
				queryKey: [BankQueryKeys.BankAccounts],
			})
		},
		onError: (error) => {
			showErrorToast(error)
		},
	})

	const handleDelete = () => {
		deleteBankAccount({ id })
	}

	return (
		<AlertDialog>
			<AlertDialogTrigger asChild>
				<Button variant="ghost" size="icon">
					<Trash2 className="h-4 w-4 text-destructive" />
				</Button>
			</AlertDialogTrigger>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>ยืนยันการลบบัญชีธนาคาร</AlertDialogTitle>
					<AlertDialogDescription>
						คุณต้องการลบบัญชีธนาคารนี้ใช่หรือไม่?
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter className="gap-2">
					<AlertDialogCancel>ยกเลิก</AlertDialogCancel>
					<AlertDialogAction
						onClick={handleDelete}
						className="bg-destructive hover:bg-destructive/90"
					>
						ยืนยัน
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	)
}
